import { render, staticRenderFns } from "./leaveConfirmation.vue?vue&type=template&id=1f428c65&"
import script from "./leaveConfirmation.vue?vue&type=script&lang=js&"
export * from "./leaveConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./leaveConfirmation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports